import { SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { DisclaimerProps } from '~/components/disclaimer/disclaimer';
import { customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

export const GlobalDisclaimerBarStyles = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	min-height: 56px;
	padding: 16px 0;
	padding-right: 40px;
	background: ${SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};

	${customBreakPoint(
		mobileBreakPoint,
		`
			padding-right: 0;
		`,
	)}
	.close-button {
		position: absolute;
		top: 0;
		right: 0;
	}
`;

export const GlobalDisclaimerLayerStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;

	.okay-button {
		width: 180px;
	}
`;

export const CategoryDisclaimerStyles = styled.div<{
	$type: DisclaimerProps['type'];
	$expanded: boolean;
	$clamped: boolean;
}>`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: ${({ $type }) => ($type === 'item' ? 'none' : `24px`)};
	border: ${({ $type }) => ($type === 'item' ? 'none' : `1px solid ${SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT}`)};
	gap: ${({ $type }) => ($type === 'audicode' ? '12px' : `none`)};

	.info {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.icon {
		min-width: fit-content;
	}

	.link {
		display: flex;
		flex-wrap: wrap;
		gap: 0 8px;
	}

	.disclaimer-content-wrapper {
		display: flex;
		flex-direction: column;
		transition: max-height 0.6s ease;
		max-height: ${({ $expanded }) => ($expanded ? '999px' : '40px')};
		overflow: hidden;
		.content {
			transition: max-height 0.6s ease;
			overflow: hidden;

			${({ $clamped }) =>
				$clamped &&
				`display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
           `}
		}
	}

	button {
		width: fit-content;
	}
`;
